// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EscrowOrderTrackingEntrySource } from '@marketplace-web/order-details/order-details-data'
import { urlWithParams } from '@marketplace-web/shared/utils'

export const INBOX_URL = '/inbox'
export const CONVERSATION_URL = (
  conversationId: number | string,
  source?: EscrowOrderTrackingEntrySource,
): string => urlWithParams(`/inbox/${conversationId}`, { source })

export const INBOX_WANT_IT_PATH = (receiverId: number | string, itemId: number | string): string =>
  `/inbox/want_it?receiver_id=${receiverId}&item_id=${itemId}`

export const INBOX_ROUTE_PATHS = {
  INBOX: 'inbox/*',
  CONVERSATION: ':id',
  WANT_IT: 'want_it',
}
